import React from 'react';
import BaseGridToolbar from '../../components/shared/toolbar/BaseGridToolbar';
import ToolbarButton from '../../components/shared/toolbar/ToolbarButton';

export function SystemAuctionLotsToolbar({
  columns,
  data,
  onScrape,
  onAdd
}) {
  return (
    <BaseGridToolbar
      title="Auction Lots"
      columns={columns}
      data={data}
      showQuickFilter
      actionButton={
        <div className="flex space-x-2">
          <ToolbarButton
            variant="contained"
            onClick={onScrape}
            startIcon={
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
              </svg>
            }
          >
            Scrape Lots
          </ToolbarButton>
          <ToolbarButton
            variant="contained"
            onClick={onAdd}
            startIcon={
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
              </svg>
            }
          >
            Add Lot
          </ToolbarButton>
        </div>
      }
    />
  );
}
